﻿export * from './loanapprovals.component';
